import { render, staticRenderFns } from "./Loader.vue?vue&type=template&id=4efbefbe&scoped=true&lang=pug&"
var script = {}
import style0 from "./Loader.vue?vue&type=style&index=0&id=4efbefbe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4efbefbe",
  null
  
)

export default component.exports